import Head from 'next/head'
import BottomCTA from '../common/components/BottomCTA'
import LearnMore from './LearnMore'
import Pitch from './Pitch'
import SustainabilityData from './SustainabilityData'
import SustainabilityFeatures from './SustainabilityFeatures'

function Sustainability() {
  return (
    <>
      <Head>
        <title>
          Sustainability and Waste Diversion - Waste Removal Services | Dimension Waste Management
        </title>
        <meta name="description" content="Dimension empowers you with the tools and tech you need to ensure that your waste management is as good for the environment as it is for your business." />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
      </Head>
      <Pitch />
      <SustainabilityData />
      <SustainabilityFeatures />
      <LearnMore />
      <BottomCTA isProviderPortal={false} />
    </>
  )
}

export default Sustainability
